import React from 'react';
import indeed from '../assets/projectsImg/indeedImg.png';
import campaignMonitor from '../assets/projectsImg/campaignMonitorImg.png';
import netmeds from '../assets/projectsImg/netmedsImg.png';
import travelocity from '../assets/projectsImg/travelocityImg.png';
import notesApp from '../assets/projectsImg/notesAppImg.png';
import quora from '../assets/projectsImg/quoraImg.png';
import booksClub from '../assets/projectsImg/booksClubImg.png';
import sbEnterprises from '../assets/projectsImg/sbEnterprises.png';
import { AiFillHtml5 } from 'react-icons/ai';
import { DiCss3, DiJavascript, DiMongodb } from 'react-icons/di';
import { RiReactjsFill } from 'react-icons/ri';
import { SiRedux, SiMui, SiTypescript } from 'react-icons/si';
import { FaBootstrap } from 'react-icons/fa';
import { FaNodeJs } from 'react-icons/fa';
// import { SiExpress } from 'react-icons/si';
// import { FaGitAlt, } from 'react-icons/fa';
import './styles.css'


const projects = [
    {
        id: 1,
        category: 'Social',
        image: booksClub,
        source: 'https://github.com/sheikhtausif/books-club-hackathon',
        view: '',
        title: 'BooksClub',
        description: 'BooksClub is an online platform where users can provide their unused books to needy people for free. It was completed in 48 hours with a team of four members.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "ReactJs"], [<SiRedux className="techIcon" />, "Redux"], [<SiMui className="techIcon" />, "Material-UI"], [<FaBootstrap className="techIcon" />, "Bootstrap"], [<FaNodeJs className="techIcon" />, "NodeJs"], [<DiMongodb className="techIcon" />, "MongoDB"],],
    },
    {
        id: 2,
        category: 'Social',
        image: quora,
        source: 'https://github.com/sheikhtausif/quora-clone',
        view: '',
        title: 'Quora Clone',
        description: `Quora is an online platform where users can clarify their own and others' doubts and users can ask their questions and share their answers over the world.`,
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "ReactJs"], [<SiRedux className="techIcon" />, "Redux"], [<SiMui className="techIcon" />, "Material-UI"], [<FaBootstrap className="techIcon" />, "Bootstrap"], [<FaNodeJs className="techIcon" />, "NodeJs"], [<DiMongodb className="techIcon" />, "MongoDB"],],
    },
    {
        id: 3,
        category: 'Booking',
        image: travelocity,
        source: 'https://github.com/sheikhtausif/travelocity-clone',
        view: 'https://travelocity-clone.vercel.app',
        title: 'Travelocity Clone',
        description: 'This is the clone of the Travelocity website. Travelocity is an online travel agency. From this website, users can book a hotel room, flights, cars, etc. across the world.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "ReactJs"], [<SiRedux className="techIcon" />, "Redux"], [<SiMui className="techIcon" />, "Material-UI"]],
    },
    {
        id: 5,
        category: 'E-Commerce',
        image: netmeds,
        source: 'https://github.com/sheikhtausif/NetmedsClone',
        view: 'https://netmeds-clone.vercel.app/',
        title: 'Netmeds Clone',
        description: 'Netmeds is a trusted Indian online pharmacy. Which provides the quick online purchase and fast delivery of prescription medications.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"]]
    },
    {
        id: 7,
        category: 'Productivity',
        image: notesApp,
        source: 'https://github.com/sheikhtausif/notes_app',
        view: 'https://note-app-neon.vercel.app',
        title: 'Notes App',
        description: 'This is an individual project. In this app, users can add, update and delete only their notes after creating an account.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "ReactJs"], [<FaBootstrap className="techIcon" />, "Bootstrap"], [<FaNodeJs className="techIcon" />, "NodeJs"], [<DiMongodb className="techIcon" />, "MongoDB"],],
    },
    {
        id: 8,
        category: 'E-Commerce',
        image: sbEnterprises,
        source: '',
        view: '',
        title: 'SB Enterprises',
        description: 'SB Enterprises is a mini e-commerce website. Where you can order Tata Water and Juice as well.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<SiTypescript className="techIcon" />, "TypeScript"], [<RiReactjsFill className="techIcon" />, "ReactJs"], [<SiMui className="techIcon" />, "Material-UI"]],
    },
    {
        id: 6,
        category: 'Others',
        image: campaignMonitor,
        source: 'https://github.com/sheikhtausif/tungabhadra_project',
        view: 'https://sheikhtausif.github.io/tungabhadra_project/',
        title: 'Campaign Monitor Clone',
        description: 'Campaign Monitor is a global technology company that provides an email marketing platform, where we have just made some of the static pages.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"]],
    },
    {
        id: 4,
        category: 'Others',
        image: indeed,
        source: 'https://github.com/sheikhtausif/indeed-clone',
        view: 'https://clone-of-indeed.netlify.app/',
        title: 'Indeed Clone',
        description: 'Indeed is a website which is a free service to job seekers, where you can upload a resume, create job alert emails, search for jobs, save them and apply to them directly.',
        tech: [[<AiFillHtml5 className="techIcon" />, "HTML5"], [<DiCss3 className="techIcon" />, "CSS3"], [<DiJavascript className="techIcon" />, "JavaScript"], [<RiReactjsFill className="techIcon" />, "ReactJs"], [<FaBootstrap className="techIcon" />, "Bootstrap"], [<SiMui className="techIcon" />, "Material-UI"]],
    },
]

export default projects;